import { useCallback, useContext } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';
import { ImportModalTypes } from '../components/Modals/ImportModalTypes.ts';
import { isBulkLengthLimitReached, isBulkTotalSizeLimitReached } from '../utils/checkBulkLimits.ts';

export const useBulkLimitCheck = (): ((fileList: any[]) => Promise<any[] | false>) => {
	const { showConfirmModal, modalStack, closeModal } = useContext(ImportStateContext);

	return useCallback(
		//TODO: add types for documents
		async (fileList: any[]): Promise<any[] | false> => {
			if (isBulkLengthLimitReached(fileList) || isBulkTotalSizeLimitReached(fileList)) {
				if (modalStack[ImportModalTypes.PROGRESS]) {
					closeModal(ImportModalTypes.PROGRESS);
				}

				return showConfirmModal(ImportModalTypes.BULK_LIMIT);
			} else {
				return fileList;
			}
		},
		[showConfirmModal, closeModal, modalStack],
	);
};
